<template>
  <v-btn class="btn app--theme-bg" :class="[classes, { disabled: disabled }]" :disabled="disabled" @keydown.prevent :elevation="elevation"
    ><v-icon v-if="icon" start :icon="icon"></v-icon>{{ name }}</v-btn
  >
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "ButtonPrimary",
  props: {
    classes: {
      type: String,
      default: "",
    },
    icon: {
      type: String,
      default: null,
    },
    name: {
      type: String,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    elevation: {
      type: Number,
      default: 2,
    },
  },
  setup(props) {
    return {
      props,
    };
  },
});
</script>

<style scoped>
.btn {
  height: 40px;
  font-weight: 600;
  text-transform: none;
  letter-spacing: 0.4px;
  font-size: 14px;
  padding: 6px 16px;
  color: #ffffff;
}
.disabled {
  background: rgba(0, 0, 0, 0.12) !important;
  color: rgba(0, 0, 0, 0.26) !important;
}
</style>
